// Mapa rota do app -> post da Central de ajuda (help.taskrush.com.br).
// Só posts que existem hoje (levantamento de 2026-09-20). Posts que faltam: BACKLOG do docs/ROADMAP.md.
// Não linkar Preços nem "Como começar" até serem revisados. Tela sem post fica sem o botão "?".
export const HELP_BASE_URL = 'https://help.taskrush.com.br'

type HelpLink = {match: RegExp; path: string}

const HELP_LINKS: HelpLink[] = [
  {match: /^\/dashboard/, path: '/visao-em-tempo-real-conheca-o-dashboard-do-taskrush/'},
  {
    match: /^\/(mytasks|tarefas|tasksbyuser)/,
    path: '/tarefas-no-taskrush-veja-como-criar-e-acompanhar/',
  },
  {match: /^\/time-tracking/, path: '/time-tracking-veja-como-funciona-no-taskrush/'},
  {match: /^\/projects/, path: '/como-cadastrar-e-gerir-projetos-no-taskrush/'},
  {match: /^\/clients/, path: '/clientes-no-taskrush-acompanhe-contratos-e-projetos/'},
  {match: /^\/contracts/, path: '/gerenciamento-de-contratos-no-taskrush/'},
  {match: /^\/users/, path: '/usuarios-e-equipes-no-taskrush-como-criar-e-configurar/'},
  {match: /^\/teams/, path: '/equipes-no-taskrush-como-criar-e-organizar-times/'},
  {match: /^\/sprints/, path: '/sprints-no-taskrush-veja-como-organizar-tarefas/'},
  {match: /^\/schedules/, path: '/cronogramas-no-taskrush/'},
  {match: /^\/calendar/, path: '/calendario-do-taskrush-visualize-suas-tarefas/'},
  {
    match: /^\/reports/,
    path: '/como-acessar-e-interpretar-seus-primeiros-relatorios-no-taskrush/',
  },
  {
    match: /^\/(admin\/client-portal-access|client-portal-tickets)/,
    path: '/portal-do-cliente-no-taskrush/',
  },
  {match: /^\/admin\/integrations/, path: '/integracoes-no-taskrush-veja-como-configurar/'},
  {match: /^\/admin\/api/, path: '/api-publica-como-fazer-integracao-personalizada/'},
  {match: /^\/(configs|notifications)/, path: '/notificacoes-ajustes-gerais/'},
  {match: /^\/indicacoes/, path: '/indicacao-taskrush/'},
]

// UTM só nos links do app para o help (medir uso). Entre posts do help o UTM deve ser removido.
export const getHelpUrlForPath = (pathname: string): string | undefined => {
  const link = HELP_LINKS.find((item) => item.match.test(pathname))
  return link ? `${HELP_BASE_URL}${link.path}?utm_source=app&utm_medium=page_help` : undefined
}
